export default __webpack_public_path__ + "static/media/webinar-card-img.cad569e9.png";